export default {
    event: 'Event',
    product: 'Product',
    service: 'Service',
    timebank: 'Time Bank'
};
